import { getIdToken } from "../../../../../Utils/misc/miscUtils.ts";
import { URL_BASE } from "../../../../../Globals.ts";

export const submitFeedback = async (user: any, feedbackText: string) => {
    try {
        if (!user) return { success: false, error: "User not authenticated" };

        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/submitFeedback`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                feedback: feedbackText
            })
        });

        if (response.ok) {
            return { success: true, data: await response.json() };
        } else {
            return { success: false, error: `Server responded with ${response.status}` };
        }
    } catch (error) {
        console.error(`Error submitting feedback: ${error}`);
        return { success: false, error: String(error) };
    }
};